import { memo } from "react";

import { DOCUMENT_NAV_GUARD_INLINE_SOURCE } from "./document-nav-guard-inline-source";

/**
 * Mount once in `<head>`. Order-insensitive relative to the analytics scripts
 * (it only registers a listener and touches no shared global besides its own
 * deadline key), but it should stay as early as practical so the guarded
 * window starts as close to first paint as possible.
 */
export const DocumentNavGuardInlineScript = memo(
  function DocumentNavGuardInlineScript({ nonce }: { nonce?: string }) {
    return (
      <script
        // Nonce attributes are stripped by the browser on server-rendered
        // scripts, so this subtree cannot be hydrated — same contract as the
        // other inline `<head>` scripts in root.tsx.
        suppressHydrationWarning
        nonce={nonce}
        dangerouslySetInnerHTML={{ __html: DOCUMENT_NAV_GUARD_INLINE_SOURCE }}
      />
    );
  },
);
